import { useState } from "react";
import { Trees } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { AddButton, SearchInput, ListCard, Empty } from "@/components/Bits";
import { FazendaFormDialog } from "@/components/FazendaFormDialog";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/lib/useFetch";

export default function FazendasPage() {
  const { user } = useAuth();
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const { data, reload } = useFetch("/fazendas", { q: q || undefined });
  const isAdmin = user.role === "admin";

  return (
    <div data-testid="fazendas-page">
      <PageHeader eyebrow="Propriedades" title="Fazendas" subtitle={isAdmin ? "Todas as propriedades cadastradas." : "Propriedades disponíveis para você."} />
      <div className="flex gap-3 mb-5">
        <SearchInput value={q} onChange={setQ} placeholder="Buscar fazenda, município ou responsável" testId="fazenda-search-input" />
        {user.role !== "tecnico" && <AddButton onClick={() => setOpen(true)} data-testid="fazenda-add-button">Nova</AddButton>}
      </div>
      {data?.length === 0 && <Empty testId="fazenda-list-empty">Nenhuma fazenda encontrada.</Empty>}
      <div className="grid md:grid-cols-2 gap-3" data-testid="fazenda-list">
        {(data || []).map((f) => (
          <ListCard key={f.fazenda_id} to={`/fazendas/${f.fazenda_id}`} icon={Trees} testId={`fazenda-card-${f.fazenda_id}`}
            title={f.nome} subtitle={`${[f.municipio, f.estado].filter(Boolean).join(" / ") || "—"} · ${f.cliente_nome || ""}`}
            meta={`${f.total_equipamentos} equipamento(s)`} />
        ))}
      </div>
      <FazendaFormDialog open={open} onOpenChange={setOpen} onSaved={reload} />
    </div>
  );
}
